import { trpc } from "../../../lib/api/trpc";

export type DocumentChunksResponse = {
  chunks: Array<{
    id: string;
    chunkIndex: number;
    content: string;
    characterCount: number;
    isIndexed: boolean;
    indexedAt: string | null;
    metadata: Record<string, unknown> | null;
  }>;
  pagination: {
    total: number;
    page: number;
    pageSize: number;
    totalPages: number;
  };
  summary: {
    totalChunks: number;
    indexedChunks: number;
    averageCharacterCount: number;
  };
};

export const useDocumentChunks = (
  documentId: string,
  page: number = 1,
  pageSize: number = 10,
) => {
  // @ts-ignore - tRPC type inference through `as any` router cast
  const { data, isLoading, isError, error, refetch } =
    trpc.documents.getChunks.useQuery(
      { documentId, page, pageSize },
      { enabled: !!documentId },
    );

  return {
    data: data as DocumentChunksResponse | undefined,
    isLoading,
    isError,
    error,
    refetch,
  };
};
